
import ConfiguratorBonusContent from "../Interfaces/ConfiguratorBonusContent";
import ConfiguratorMetaobject from "../Interfaces/ConfiguratorMetaobject";
import ShapeInterface from "../Interfaces/ShapeInterface";
import OptionInterface from "../Interfaces/OptionInterface";
import ModelInterface from "../Interfaces/ModelInterface";
const CONFIGURATOR_RESET_PARAM = 'reset_configurator';
const CONFIGURATOR_JOURNEY_SOURCE_KEY = 'configuratorJourneySource';

const getUrlParams = () => {
    const queryString = window.location.search;
    return new URLSearchParams(queryString);
}

const getParamByName = (name: string) => {
    return getUrlParams().get(name) ?? '';
}

const setParamByName = (name: string, value: string) => {
    const params = getUrlParams();
    params.set(name, value);
    window.history.pushState({}, '', `${window.location.pathname}?${params.toString()}`);
}
const getFormFromSessionStorage = () => {    
    if (shouldResetConfiguratorFromQuery()) {
        sessionStorage.removeItem(getSessionStorageKey());
        removeParamByName(CONFIGURATOR_RESET_PARAM);
        return null;
    }
    const storageItem = sessionStorage.getItem(getSessionStorageKey());
    return !storageItem ? null : JSON.parse(storageItem);
}

const getCurrentStep = () => {
    const step = getParamByName('step');
    if (!step) {
        return -1;
    }
    return parseInt(step) - 2; //subtract 2 to account for pre configurator steps
}


const getSessionStorageKey = () => {
    return `configuratorForm:${metaobject?.type}:${metaobject?.handle}`;
}

const setValueFromProperty = (object: any, key: string, properties: any) => {
    let propertyValue = properties[`_${key}`];
    if(key == 'fold_direction'){
        propertyValue = properties[`_fold_location`];
    }
    if(key == 'shape' && properties[`_shape`]){
        propertyValue = properties[`_shape`].replaceAll(' ', '_');
    }
    if (!propertyValue) return;
    if(propertyValue.toLowerCase() == 'true' || propertyValue.toLowerCase() == 'false') {
        object[key] = propertyValue == 'true';
        return;
    }
    object[key] = propertyValue;
}

const setVariantValue = (object: any, key: string, lineItem: any) => {
    object[key] = {
        value: lineItem.properties?._value ?? lineItem.variant_title,
        variantId: lineItem.variant_id,
        price: lineItem.price,
        productId: lineItem.product_id,
        image: lineItem.image,
        message: lineItem.properties?._message,
        disableContinuation: lineItem.properties?.disableContinuation
    }
}

const setMutiselectVariant = (object: any, key: string, lineItem: any) => {
    const array = object['variants'] ?? [];
    array.push({
        associatedVariants: lineItem.properties?._associatedVariants?.split(','),
        field: key,
        value: lineItem.properties?._value ?? lineItem.variant_title,
        variantId: lineItem.variant_id,
        price: lineItem.price,
        productId: lineItem.product_id,
        image: lineItem.image,
    })
    object['variants'] = array;
}

const removeParamByName = (name: string) => {
    const params = getUrlParams();
    if (!params.has(name)) return;
    params.delete(name);
    const nextQuery = params.toString();
    const nextUrl = nextQuery ? `${window.location.pathname}?${nextQuery}` : window.location.pathname;
    window.history.replaceState({}, '', nextUrl);
}

const shouldResetConfiguratorFromQuery = () => {
    const resetParam = getParamByName(CONFIGURATOR_RESET_PARAM).toLowerCase();
    return ['1', 'true', 'yes'].includes(resetParam);
}



const getStoredForm = async (callback: (configuratorForm: any, itemKeys: string[]) => void) => {
    const key = getParamByName('key');
    if (!key) {
        return;
    }

    fetch(`${window.routes.cart_url}.json`)
        .then((res) => res.text())
        .then((result) => {
            const parsedState = JSON.parse(result);
            if (parsedState.error) {
                return;
            }

            const parent_variant = parsedState.items.filter((item: any) => item.key == key)[0];
            if (!parent_variant) {
                console.error("Populate Info: Variant Not Found");
                return;
            }

            const coverID = parent_variant.properties._cover_id || false;
            const items = parsedState.items.filter((item: any) => item.properties._cover_id == coverID);
            const parentFormValues = ["brand", "model", "shape", "customFeatures", "customShape", "fold_direction", "panels", "strap_location", "custom_tiedown_distance"];
            let generatedForm = {
                attestation: true,
                dimensionsValid: true,
                customStrapLocation: parent_variant.properties?._customStrapLocation == 'true',
                dimension_a: {
                    value: parent_variant.properties?._dimension_a,
                    disableContinuation: false,
                    message: "",
                    price: "",
                },
                dimension_b: {
                    value: parent_variant.properties?._dimension_b,
                    disableContinuation: false,
                    message: "",
                    price: "",
                },
                dimension_c: {
                    value: parent_variant.properties?._dimension_c,
                    disableContinuation: false,
                    message: "",
                    price: "",
                },
                dimension_d: {
                    value: parent_variant.properties?._dimension_d,
                    disableContinuation: false,
                    message: "",
                    price: "",
                },
                dimension_acrylic_height: {
                    value: parent_variant.properties?._dimension_acrylic_height,
                    disableContinuation: false,
                    message: "",
                    price: "",
                },
                dimension_tub_height: {
                    value: parent_variant.properties?._dimension_tub_height,
                    disableContinuation: false,
                    message: "",
                    price: "",
                },
            };
            parentFormValues.forEach((key) => setValueFromProperty(generatedForm, key, parent_variant.properties));
            items.forEach((item: any) => {
                if(item.key == parent_variant.key) return;
                if (!item?.properties?._multi_entry)
                    return setVariantValue(generatedForm, item.properties?._cover_field, item);
                return setMutiselectVariant(generatedForm, item.properties?._cover_field, item);
            });

            let item_keys = items.map((item: any) => item.key);
            // Check for cover components without a cover ID to remove
            const proplessComponents = parsedState.items.filter((item: any) =>
                (typeof item.properties._cover_id == 'undefined') &&
                (
                    item.product_type.toLowerCase().includes('cover') ||
                    item.product_type.toLowerCase().includes('couverture')
                ) &&
                (
                    item.product_type.toLowerCase().includes('component') ||
                    item.product_type.toLowerCase().includes('composant')
                )
            );
            const remove_keys = proplessComponents.map((item: any) => item.key);
            if (remove_keys.length > 0) {
                item_keys = item_keys.concat(remove_keys);
            }

            callback(generatedForm, item_keys);
        });
}

const getSrcSet = (src: string, sizes: number[]) => {
    if (!src) return '';
    return sizes.map((size) => `${src}&width=${size} ${size}w`).join(',');
}

const getImageSizes = (defaultValue: string, sizeValueArray: { screen: number, view: string }[]) => {
    if (!defaultValue) return '';
    const stringArray = sizeValueArray.sort((a, b) => a.screen - b.screen).map((item) => `(max-width: ${item.screen}px) ${item.view}`)
    stringArray.push(defaultValue);
    return stringArray.join(', ');
}

//const formatMoney = (value: number) => (value / 100).toFixed(2);
const formatMoney = (value: string) => `${window.currencySymbol}${(parseFloat(value) / 100).toFixed(2)}`;

function toCamelCase(str: string) {
    return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
        if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
        return index === 0 ? match.toLowerCase() : match.toUpperCase();
    });
}

function toTitleCase(str: string) {
    return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}

const restartConfigurator = () => {
    sessionStorage.removeItem(getSessionStorageKey());
    const origin = getParamByName('origin');
    window.location.href = origin ? origin : window.location.href.split('?')[0];
}


const getStoredConfiguratorJourneySource = () => {
    try {
        return JSON.parse(sessionStorage.getItem(CONFIGURATOR_JOURNEY_SOURCE_KEY) || 'null');
    } catch {
        return null;
    }
}

const getConfiguratorModelSource = () => {
    if ((selectedConfiguratorModel?._brand && selectedConfiguratorModel?._model)
        || (getParamByName('brand') && getParamByName('model'))) {
        return 'landing_page_model';
    }

    return 'custom_pdp_brand_model_selection';
}

const buildConfiguratorJourneySource = () => {
    return {
        entry_path: window.location.pathname,
        entry_model_source: getConfiguratorModelSource(),
    };
}

const isModelEntryContext = () => {
    return Boolean(
        (selectedConfiguratorModel?._brand && selectedConfiguratorModel?._model)
        || (getParamByName('brand') && getParamByName('model'))
        || getParamByName('origin')
    );
}

const initializeConfiguratorJourneySource = () => {
    const source = buildConfiguratorJourneySource();

    sessionStorage.setItem(CONFIGURATOR_JOURNEY_SOURCE_KEY, JSON.stringify(source));
    return source;
}

const getConfiguratorJourneySource = () => {
    const storedSource = getStoredConfiguratorJourneySource();
    if (storedSource && isModelEntryContext()) {
        return storedSource;
    }

    if (storedSource) {
        clearConfiguratorJourneySource();
    }

    return buildConfiguratorJourneySource();
}

const clearConfiguratorJourneySource = () => {
    sessionStorage.removeItem(CONFIGURATOR_JOURNEY_SOURCE_KEY);
}

const shapes = (window.shapes as ShapeInterface[]) ?? [];
const metaobject = window.configuratorMetaobject as ConfiguratorMetaobject;
const selectedConfiguratorModel = (window as any).selectedConfiguratorModel as ModelInterface | null;
const howToMeasure = window.howToMeasure as ConfiguratorBonusContent;
const lengthHelp = window.lengthHelp as ConfiguratorBonusContent;
const translations = (window as any).translations as any;
const sectionSettings = (window as any).sectionSettings as { [key: string]: string };
const icons = (window as any).configuratorIcons as { [key: string]: string };
const cart = (window as any).cart as { currency: { symbol: string } };
const configuratorOptionsArray = [
    {
        "value": "model",
        "text": translations.options.model
    },
    {
        "value": "brand",
        "text": translations.options.brand,
    },
    {
        "value": "cover",
        "text": ""
    },
    {
        "value": "shape",
        "text": translations.options.shape,
    },
    {
        "value": "custom_shape",
        "text": translations.options.custom_shape,
    },
    {
        "value": "dimension_a",
        "text": "Dimension A"
    },
    {
        "value": "dimension_b",
        "text": "Dimension B"
    },
    {
        "value": "dimension_c",
        "text": "Dimension C"
    },
    {
        "value": "dimension_d",
        "text": "Dimension D"
    },
    {
        "value": "dimension_acrylic_height",
        "text": sectionSettings.label_acrylic_height || "Acrylic Height"
    },
    {
        "value": "dimension_tub_height",
        "text": sectionSettings.label_tub_height || "Tub Height"
    },
    {
        "value": "oversize_fee",
        "text": translations.options.oversize_fee
    },
    {
        "value": "panels",
        "text": translations.options.panels
    },
    {
        "value": "fold_direction",
        "text": translations.options.fold_direction
    },
    {
        "value": "strap_location",
        "text": translations.options.strap_location
    },
    {
        "value": "strap_length",
        "text": translations.options.strap_length
    },
    {
        "value": "skirt_length",
        "text": translations.options.skirt_length
    },
    {
        "value": "color",
        "text": translations.options.color
    },
    {
        "value": "handle_option",
        "text": translations.options.handles
    },
    {
        "value": "additional_handle_options",
        "text": translations.options.additional_handles
    },
    {
        "value": "upgrade_and_accessory_package",
        "text": translations.options.package
    },
    {
        "value": "upgrades",
        "text": translations.options.upgrades
    },
    {
        "value": "accessories",
        "text": translations.options.accessories
    },
    {
        "value": "custom_tiedown_distance",
        "text": translations.options.custom_tiedown_distance
    }
];
const configuratorOptions = (configuratorOptionsArray as OptionInterface[]) ?? [];

export {
    getUrlParams,
    getParamByName,
    getStoredForm,
    getFormFromSessionStorage,
    getCurrentStep,
    getSessionStorageKey,
    initializeConfiguratorJourneySource,
    getConfiguratorJourneySource,
    clearConfiguratorJourneySource,
    setParamByName,
    formatMoney,
    toTitleCase,
    toCamelCase,
    restartConfigurator,
    getSrcSet,
    getImageSizes,
    shapes,
    metaobject,
    selectedConfiguratorModel,
    translations,
    sectionSettings,
    icons,
    howToMeasure,
    lengthHelp,
    cart,
    configuratorOptions
}
